/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_Users_FoundInputs */

const en_no_users_found = /** @type {(inputs: No_Users_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No users found.`)
};

const es_no_users_found = /** @type {(inputs: No_Users_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron usuarios.`)
};

/**
* | output |
* | --- |
* | "No users found." |
*
* @param {No_Users_FoundInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const no_users_found = /** @type {((inputs?: No_Users_FoundInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Users_FoundInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_no_users_found(inputs)
	return es_no_users_found(inputs)
});